import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './index.css'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
import 'vue3-carousel/dist/carousel.css'

// vue-toast-notification
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css';

// v-viewer
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

// For setting title
import titleMixin from './mixins/title'

// leaflet
// 設定預設 marker 影像
import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus)
  .use(VueToast, {
    position: 'top'
  })
  .use(VueViewer)
  .mixin(titleMixin)
  .mount('#app')
